import { useEffect } from 'react';
import MESSAGE_TYPES from '../constants/MESSAGE_TYPES';
import Messager from '../lib/messager';
import useBasketSize from './useBasketSize';
import useTranslate from './useTranslate';
import { META_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import type { IStateController } from '../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../lib/widget/state/state.types';

const useViewModeToggle = () => {
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);
  const { Widget } = window;
  const { t } = useTranslate();
  const basketSize = useBasketSize();

  const toggle = () => {
    if (stateController.isDragging) return;
    const schemeMode = !Widget.schemeMode;

    Messager.send({
      type: MESSAGE_TYPES.CHANGE_SCHEME_MODE,
      isScheme: schemeMode,
    });
    Widget.metaController.emit(META_EVENTS.CHANGE_SECTOR, null);
    Widget.setSchemeMode(schemeMode);

    Widget.isShowTable = schemeMode;

    if (schemeMode) {
      stateController.unlock();
      Widget.pricesController.setSchemePrices();
      stateController.emit(stateController.events.WIDGET_RERENDER);
    } else {
      stateController.lock();
      Widget.notificationController.hide();
    }
  };

  const onMessageReceived = (event) => {
    if (event.data.type === MESSAGE_TYPES.EXIT_FULLSCREEN && !Widget.schemeMode) toggle();
  };

  useEffect(() => {
    window.addEventListener('message', onMessageReceived, false);
    return () => {
      setTimeout(() => window.removeEventListener('message', onMessageReceived, false), 300);
    };
  }, []);

  return { toggle, t, basketSize };
};

export default useViewModeToggle;
